export const COMPLIANCE_TYPES: any = Object.freeze({
  INDIVIDUAL: 'Individual',
  NONE: 'None'
});
